import { render } from "./user-card-view-popup.vue?vue&type=template&id=580f6ba6"
import script from "./user-card-view-popup.vue?vue&type=script&setup=true&lang=js"
export * from "./user-card-view-popup.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/administration/users/user-card-view-popup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "580f6ba6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('580f6ba6', __exports__)) {
    api.reload('580f6ba6', __exports__)
  }
  
  module.hot.accept("./user-card-view-popup.vue?vue&type=template&id=580f6ba6", () => {
    api.rerender('580f6ba6', render)
  })

}


export default __exports__